export const siteChromeEn = {
  productName: 'Portcierge',
  nav: {
    home: 'Home',
    about: 'About',
    contact: 'Contact',
    support: 'Support',
    clients: 'Clients',
    listBuilder: 'List Builder',
    myTrips: 'My Trips',
  },
  auth: {
    signIn: 'Sign In',
    logout: 'Logout',
    settings: 'Settings',
    userFallback: 'User',
  },
  theme: {
    light: 'Light mode',
    dark: 'Dark mode',
    system: 'System default',
  },
  footer: {
    terms: 'Terms',
    privacy: 'Privacy',
    getApp: 'Get the App',
  },
} as const;
